import React, { Component, ReactNode } from "react";
import htmlParse from "html-react-parser";
import commonContext, { AppContext } from "../../context/common";
import { App, leadType } from "../../../app";
import V from "../../constents/validation";
import { Utilities } from "../../utils/utilities";

interface IProps {
    label?: string;
    prefix?: string;
    prefixClass?: string;
    errorText?: string;
    infoText?: string;
    name?: string;
    handlerOnChange?: Function;
    value?: any;
    readonly?: boolean;
    min?: number;
    max?: number;
    error?: boolean;
    errorClass?: string;
}
interface IState {
    prefixClass: string;
}
class InputForm extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    leadError: any;
    setLeadError: Function;
    setLead: Function;
    utils: Utilities;
    constructor(props: IProps) {
        super(props);
        this.state = {
            prefixClass: this.props.prefixClass
                ? `openSans-Reg ${this.props.prefixClass}`
                : "WebRupee rupees-code",
        };
    }
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        this.leadError = (this.context as AppContext).leadError;
        this.setLeadError = (this.context as AppContext).setLeadError;
        this.setLead = (this.context as AppContext).setLead;
        this.utils = (this.context as AppContext).utils as Utilities;
        let labelMessage: ReactNode,
            errorMessage: ReactNode,
            infoMessage: ReactNode,
            prifixMessage: ReactNode = "";
        if (this.props.label) {
            labelMessage = (
                <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500">
                    {this.props.label}
                </label>
            );
        }
        if (this.leadError[this.props.name]) {
            errorMessage = (
                <span
                    className={
                        " error-msg-25 text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm   " +
                        (this.props.errorClass ? this.props.errorClass : "")
                    }
                >
                    {this.leadError[this.props.name]}
                </span>
            );
        }
        if (this.props.infoText) {
            infoMessage = (
                <span
                    className={
                        (this.leadError[this.props.name] ? "hidden " : "") +
                        "error-msg-25 text-gray-500 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm " +
                        (this.props.errorClass ? this.props.errorClass : "")
                    }
                >
                    {htmlParse(this.props.infoText)}
                </span>
            );
        }
        if (this.props.prefix) {
            prifixMessage = (
                <span
                    className={
                        "absolute text-base md:text-base lg:text-lg xl:text-xl text-gray-500 " +
                        this.state.prefixClass
                    }
                >
                    {this.props.prefix}
                </span>
            );
        }

        return (
            <>
                {labelMessage}
                {prifixMessage}
                <input
                    autoComplete="off"
                    type="text"
                    className={
                        "mt-1 mb-4 sm:mb-4 md:mb-6 lg:mb-6 xl:mb-6 focus:ring-gray-500 focus:border-gray-500 block w-full text-base md:text-base lg:text-lg xl:text-xl border-gray-300 border-b-2 border-gray-200 " +
                        (this.props.prefix
                            ? this.props.prefixClass
                                ? "pl-10"
                                : "pl-5"
                            : "")
                    }
                    name={this.props.name}
                    onChange={async (e) => {
                        let error = {};
                        error[this.props.name] = e.target.value;
                        await this.setLead(error);
                        await this.props.handlerOnChange(e);
                    }}
                    // value={this.props.value}
                    defaultValue={this.props.value}
                    readOnly={this.props.readonly}
                    min={this.props.min}
                    max={this.props.max}
                />
                {errorMessage}
                {infoMessage}
            </>
        );
    }
}

export default InputForm;
